export const METRIC_HINTS = {
  activeUsers: "Users with at least one engaged session in the date range. The headline number for real usage. Counted per tracked login, so the same person on an untracked browser/device can occasionally be double-counted.",
  totalUsers: "All users who triggered any event, including those who left immediately. Always ≥ Active users.",
  newUsers: "Users whose very first session ever fell within this date range. Same tracked-identity caveat as Active users.",
  sessions: "A group of interactions. A new session starts after 30 min of inactivity, midnight in the property's timezone, or a campaign change.",
  views: "Total page-view events. Reloads and back-navigation count again.",
  bounceRate: "% of sessions that did not engage. In GA4, bounceRate = 1 − engagementRate.",
  engagementRate: "Engaged sessions / Total sessions. An engaged session is ≥ 10s, has 2+ pageviews, or has a conversion event.",
  avgSessionDuration: "Mean time from session start to last event in the session.",
};

export function fmtNumber(n) {
  if (n == null) return "--";
  return Number(n).toLocaleString();
}

export function fmtPct(n) {
  if (n == null) return "--";
  return `${(Number(n) * 100).toFixed(1)}%`;
}

export function fmtDuration(seconds) {
  if (seconds == null) return "--";
  const s = Math.round(Number(seconds));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  const rem = s % 60;
  return `${m}m ${rem}s`;
}

export function pctLabel(v) {
  if (v == null || v === 0) return "";
  return `${(Number(v) * 100).toFixed(1)}%`;
}

export const AXIS_TITLE_STYLE = { fontSize: 12, fill: "#0f172a", fontWeight: 600 };
export const LEGEND_STYLE = { paddingTop: 12, fontSize: 12 };

export function xLabel(value) {
  return { value, position: "insideBottom", offset: -2, style: { ...AXIS_TITLE_STYLE, textAnchor: "middle" } };
}

export function yLabel(value) {
  return { value, angle: -90, position: "insideLeft", style: { ...AXIS_TITLE_STYLE, textAnchor: "middle" } };
}

// GA4 Data API allows 10 concurrent requests per property — the dashboard
// fires 12 chart requests (plus filter-options), so cap the burst below it.
export const MAX_CONCURRENT_REQUESTS = 8;

export function createRequestPool(max) {
  let active = 0;
  const queue = [];
  const pump = () => {
    while (active < max && queue.length > 0) {
      const { fn, resolve, reject } = queue.shift();
      active++;
      fn().then(resolve, reject).finally(() => { active--; pump(); });
    }
  };
  return (fn) => new Promise((resolve, reject) => { queue.push({ fn, resolve, reject }); pump(); });
}

export const COMPARE_COLORS = {
  current: "#3b82f6",
  previous: "#475569",
  previousBar: "#94a3b8",
  up: "#10b981",
  down: "#ef4444",
  app: "#8b5cf6",
};
